import {FaGetPocket, FaLine} from 'react-icons/fa';
import {FaXTwitter} from 'react-icons/fa6';
import {MdFacebook} from 'react-icons/md';
import {
  createFacebookShareUrl,
  createHatenaShareUrl,
  createLineShareUrl,
  createPocketShareUrl,
  createXShareUrl,
} from '../../core/factories/shared/createShareUrl';
import {CommonLink} from './CommonLink';

export const ShareButtonsForleftSideBar: React.FC<{
  title: string;
  currentUrl: string;
}> = ({title, currentUrl}) => {
  return (
    <div className="flex justify-between">
      <CommonLink
        className="bg-sns-facebook-blue w-[30px] h-[30px] pc:hover:opacity-80 rounded-4 flex justify-center items-center"
        href={createFacebookShareUrl({currentUrl})}
        target="_blank"
        rel="noreferrer"
      >
        <MdFacebook className="text-white" />
      </CommonLink>
      <CommonLink
        className="bg-sns-x-black text-white w-[30px] h-[30px]  pc:hover:opacity-80 rounded-4 flex justify-center items-center"
        href={createXShareUrl({currentUrl, title})}
        target="_blank"
        rel="noreferrer"
      >
        <FaXTwitter size={20} />
      </CommonLink>
      <CommonLink
        className="bg-sns-hatena-bule text-white w-[30px] h-[30px]  pc:hover:opacity-80 rounded-4 flex justify-center items-center"
        href={createHatenaShareUrl({currentUrl})}
        target="_blank"
        rel="noreferrer"
      >
        B!
      </CommonLink>
      <CommonLink
        className="bg-sns-line-green text-white w-[30px] h-[30px] pc:hover:opacity-80 rounded-4 flex justify-center items-center"
        href={createLineShareUrl({currentUrl, title})}
        target="_blank"
        rel="noreferrer"
      >
        <FaLine size={20} />
      </CommonLink>
      <CommonLink
        className="bg-sns-pocket-red text-white w-[30px] h-[30px] pc:hover:opacity-80 rounded-4 flex justify-center items-center"
        href={createPocketShareUrl({currentUrl, title})}
        target="_blank"
        rel="noreferrer"
      >
        <FaGetPocket />
      </CommonLink>
    </div>
  );
};
